import {ReactNode} from "react";
import {css} from "@panda/css";
import {string} from "yup";

import {validationMessages} from "../../../form/utils/validation_messages";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {useAppSelector} from "../../../store/hooks";
import {getCheckboxConfigBySource} from "../../constants/lead/lead_modal_checkbox_options";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {normalizeLeadQuestions} from "../../utils/lead/normalize_lead_questions";
import {LeadFormQuestionsSlot} from "./slots/LeadFormQuestionsSlot";
import {LeadFormBase} from "./LeadFormBase";

const extraSchema = {
    userMessage: string().when("questions", {
        is: (questions: string[]) => questions.some((q) => q === "inny"),
        then: (schema) => schema.min(1, validationMessages.required).max(500, validationMessages.maxLength),
        otherwise: (schema) => schema.notRequired()
    })
};

interface IProps {
    handleModalClose: (forceClose?: boolean) => void;
    onSuccessfulSubmit: (
        sentApplication: IApplicationData | null,
        offer?: IOfferDetailApplication,
        property?: IPropertyDetailApplication,
        recommendedFilters?: Record<string, string>
    ) => Promise<void>;
    isTwoColumnGrid?: boolean;
    initialLeadFormValues: IApplicationFormValues | null;
    customHeader: ReactNode;
    showRodoInFooter?: boolean;
    onSubmitDraft?: (values: IApplicationFormValues) => Promise<void>;
}

export const LeadFormAskForFullOffer = (props: IProps) => {
    const {handleModalClose, onSuccessfulSubmit, initialLeadFormValues, isTwoColumnGrid, customHeader, showRodoInFooter, onSubmitDraft} = props;

    const source = useAppSelector((state) => state.mainLead.source);
    const checkboxConfig = getCheckboxConfigBySource(source);
    const allOptions = [...checkboxConfig.baseOptions, ...checkboxConfig.moreOptions];

    return (
        <LeadFormBase<{questions: string[]; userMessage: string}>
            config={{
                initialLeadFormValues,
                onSuccessfulSubmit,
                handleModalClose,
                onSubmitDraft,
                extraDefaultValues: {questions: [], userMessage: ""},
                extraSchema: extraSchema,
                transformFormValues: (values) => {
                    const {questions: _q, userMessage: _um, ...baseValues} = values;

                    return {
                        ...baseValues,
                        additionalQuestions: normalizeLeadQuestions(allOptions, values.questions, values.userMessage)
                    };
                }
            }}
            customHeader={customHeader}
            buttonText="Wyślij"
            showRodoInFooter={showRodoInFooter}
            formWrapperClassName={formWrapperStyles}
            footerWrapperClassName={formFooterStyles}
        >
            {() => <LeadFormQuestionsSlot isTwoColumnGrid={isTwoColumnGrid} />}
        </LeadFormBase>
    );
};

const formWrapperStyles = css({
    h: "100%",
    md: {
        h: "auto"
    }
});

const formFooterStyles = css({
    position: "sticky",
    bottom: 0,
    zIndex: 20,
    pt: 2,
    backgroundColor: "#fff",
    _before: {
        content: '""',
        position: "absolute",
        top: "-24px",
        left: 0,
        right: 0,
        h: "24px",
        background: "linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))",
        pointerEvents: "none"
    },
    md: {
        position: "static",
        pt: 0,
        backgroundColor: "transparent",
        _before: {
            display: "none"
        }
    }
});
import {ReactNode} from "react";
import {css} from "@panda/css";
import {string} from "yup";

import {validationMessages} from "../../../form/utils/validation_messages";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {useAppSelector} from "../../../store/hooks";
import {getCheckboxConfigBySource} from "../../constants/lead/lead_modal_checkbox_options";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {normalizeLeadQuestions} from "../../utils/lead/normalize_lead_questions";
import {LeadFormQuestionsSlot} from "./slots/LeadFormQuestionsSlot";
import {LeadFormBase} from "./LeadFormBase";

const extraSchema = {
    userMessage: string().when("questions", {
        is: (questions: string[]) => questions.some((q) => q === "inny"),
        then: (schema) => schema.min(1, validationMessages.required).max(500, validationMessages.maxLength),
        otherwise: (schema) => schema.notRequired()
    })
};

interface IProps {
    handleModalClose: (forceClose?: boolean) => void;
    onSuccessfulSubmit: (
        sentApplication: IApplicationData | null,
        offer?: IOfferDetailApplication,
        property?: IPropertyDetailApplication,
        recommendedFilters?: Record<string, string>
    ) => Promise<void>;
    isTwoColumnGrid?: boolean;
    initialLeadFormValues: IApplicationFormValues | null;
    customHeader: ReactNode;
    showRodoInFooter?: boolean;
    onSubmitDraft?: (values: IApplicationFormValues) => Promise<void>;
}

export const LeadFormAskForFullOffer = (props: IProps) => {
    const {handleModalClose, onSuccessfulSubmit, initialLeadFormValues, isTwoColumnGrid, customHeader, showRodoInFooter, onSubmitDraft} = props;

    const source = useAppSelector((state) => state.mainLead.source);
    const checkboxConfig = getCheckboxConfigBySource(source);
    const allOptions = [...checkboxConfig.baseOptions, ...checkboxConfig.moreOptions];

    return (
        <LeadFormBase<{questions: string[]; userMessage: string}>
            config={{
                initialLeadFormValues,
                onSuccessfulSubmit,
                handleModalClose,
                onSubmitDraft,
                extraDefaultValues: {questions: [], userMessage: ""},
                extraSchema: extraSchema,
                transformFormValues: (values) => {
                    const {questions: _q, userMessage: _um, ...baseValues} = values;

                    return {
                        ...baseValues,
                        additionalQuestions: normalizeLeadQuestions(allOptions, values.questions, values.userMessage)
                    };
                }
            }}
            customHeader={customHeader}
            buttonText="Wyślij"
            showRodoInFooter={showRodoInFooter}
            formWrapperClassName={formWrapperStyles}
            footerWrapperClassName={formFooterStyles}
        >
            {() => <LeadFormQuestionsSlot isTwoColumnGrid={isTwoColumnGrid} />}
        </LeadFormBase>
    );
};

const formWrapperStyles = css({
    h: "100%",
    md: {
        h: "auto"
    }
});

const formFooterStyles = css({
    position: "sticky",
    bottom: 0,
    zIndex: 20,
    pt: 2,
    backgroundColor: "#fff",
    _before: {
        content: '""',
        position: "absolute",
        top: "-24px",
        left: 0,
        right: 0,
        h: "24px",
        background: "linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))",
        pointerEvents: "none"
    },
    md: {
        position: "static",
        pt: 0,
        backgroundColor: "transparent",
        _before: {
            display: "none"
        }
    }
});
